import videoPlaceholder from "../assets/video-placeholder.png"

//Splits an array in multiple chunks (arrays) big as the given size
export const chunk = (array, chunkSize) => {
  if (array.length > 0) {
    const chunkedArray = []
    for (let i = 0; i < array.length; i += chunkSize)
      chunkedArray.push(array.slice(i, i + chunkSize))
    return chunkedArray
  }
}

export const getVideoThumb = link =>
  new Promise(resolve => {
    if(link && link.includes("youtu.be")) {
      resolve(`https://img.youtube.com/vi/${link.replace("https://youtu.be/", "")}/0.jpg`)
    } else if (link && link.includes("vimeo")) {
      fetch(`http://vimeo.com/api/v2/video/${link.replace("https://vimeo.com/", "")}.json`)
        .then(res => res.json())
        .then(data => {
          resolve(data[0].thumbnail_large)
        })
        .catch(console.log)
    } else {
      resolve(videoPlaceholder)
    }
  })



// WEBPACK FOOTER //
// ./src/helpers/utils.js